module.exports = __webpack_public_path__ + "img/2.edd219e0.jpg";